import { InternalServerError } from './errors';
import {
  HttpApiEndpoint,
  HttpApiGroup,
  HttpApiSchema,
  OpenApi,
} from 'effect/http-api';
// Canonical response schema, derived from VOICE_DEFS (the single source of
// truth) rather than the staging-generated snapshot — see ./schemas/voice.
import { GetListVoices200 } from './schemas/voice';
import { Schema } from 'effect';

// Designed voices (`persona-<uuid>` model ids) are listed only for clients
// that ask: an older client drops a voice id it cannot resolve and would play
// the default voice instead.
const ListVoicesQuery = Schema.Struct({
  include: Schema.optional(Schema.Literal('personas')),
});

const listVoicesEndpoint = HttpApiEndpoint.get('ListVoices', '/voices', {
  query: ListVoicesQuery,
  success: GetListVoices200.pipe(HttpApiSchema.status(200)),
  error: InternalServerError,
})
  .annotate(OpenApi.Summary, 'List Available Voices')
  .annotate(
    OpenApi.Description,
    'Get all available voices for text-to-speech synthesis.',
  );

export const voicesGroup = HttpApiGroup.make('Voices')
  .add(listVoicesEndpoint)
  .prefix('/v2');
